<template>
  <div class="animate-pulse rounded-full bg-gray-300" :class="classString">
    <p>&nbsp;</p>
  </div>
</template>

<script>
export default {
  name: "loading",
  props: {
    width: {
      type: String,
      default: 'w-24'
    },
    height: {
      type: String,
      default: 'h-4'
    }
  },
  computed: {
    classString(){
      return this.width + " " + this.height;
    }
  }
}
</script>

<style scoped>

</style>